import Ddl from "../../../models/common/Ddl";

const SelectUtility = {
    getSelectValue(opts?: any, ids?: any) {
        if (!ids || !opts) {
            return;
        }

        if (!Array.isArray(ids)) {
            ids = [ids];
        }
        return opts.filter((o: any) => ids.some((i: any) => i === o.value));
    },

    getSelectOptions(opts?: Ddl[]) {
        if (!opts) return;
        return opts.map((o: Ddl) => ({ value: o.id, label: o.value }));
    }
}

export default SelectUtility;